// extracted by mini-css-extract-plugin
module.exports = {"comment":"comment_comment__fBrbG","header":"comment_header__oMc9U","username":"comment_username___7QB7","body":"comment_body__Z3Jt5"};